export const Birthday = {
  PetBirthday: 'pet-birthday',
  BackBtn: 'back-btn',
  NextBtn: 'next-btn',
} as const;
